import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Filter } from "src/app/core/models/Filter";
import { COL_TYPES } from "../table/table.interface";
import { DatePipe } from "@angular/common";
@Component({
	selector: "app-dynamic-filter",
	templateUrl: "./dynamic-filter.component.html",
	styleUrl: "./dynamic-filter.component.scss",
})
export class DynamicFilterComponent {
	@Input() collection: string;
	@Input() fields: { name: string; label: string; type: string }[];
	@Input() hidden: boolean = false;
	@Output() searchResults = new EventEmitter<string>();
	public selectedField: { name: string; label: string; type: string };
	COL_TYPES = COL_TYPES;
	searchForm: FormGroup;
	filterList: Filter[] = [];
	operators = {
		string: [
			{ value: "contains", label: "contient" },
			{ value: "eq", label: "égal" },
			{ value: "ne", label: "n'est pas égal à" },
		],
		number: [
			{ value: "eq", label: "égal" },
			{ value: "ne", label: "n'est pas égal à" },
			{ value: "gt", label: "plus grand que" },
			{ value: "lt", label: "plus petit que" },
			{ value: "gte", label: "plus grand ou égal à" },
			{ value: "lte", label: "plus petit ou égal à" },
		],
		date: [
			{ value: "eq", label: "égal" },
			{ value: "ne", label: "n'est pas égal à" },
			{ value: "gt", label: "après" },
			{ value: "lt", label: "avant" },
			{ value: "gte", label: "le ou après" },
			{ value: "lte", label: "le ou avant" },
		],
		bool: [
			{ value: "eq", label: "égal" },
			{ value: "ne", label: "n'est pas égal à" },
		],
	};

	constructor(
		private fb: FormBuilder,
		private datePipe: DatePipe
	) {
		this.searchForm = this.fb.group({
			field: ["", Validators.required],
			operator: ["", Validators.required],
			value: ["", Validators.required],
		});
	}
	public onSearch() {
		const { field, operator, value } = this.searchForm.value;
		let formattedValue = value;
		if (this.selectedField?.type === COL_TYPES.DATE) {
			formattedValue = this.datePipe.transform(value, "yyyy-MM-dd");
		}
		const label = this.getOperatorLabelByTypeAndValue(this.selectedField?.type, operator);
		this.filterList.push({ name: field, operator: operator, value: formattedValue, label: label });
		this.searchResults.emit(this.buildFilters());
		this.resetValueFormFilter();
	}
	private buildFilters(): string {
		const filters = this.filterList.map((filter, index) => `filters[$and][${index}][${filter.name}][$${filter.operator}]=${filter.value}`).join("&");
		return filters;
	}
	public removeFilter(filterToRemove: Filter) {
		this.filterList = this.filterList.filter((filter) => filter.name !== filterToRemove.name || filter.operator !== filterToRemove.operator || filter.value !== filterToRemove.value);
		this.searchResults.emit(this.buildFilters());
	}
	public listStringToObject(liststring: string[]): any[] {
		return liststring.map((valueString) => {
			nom: valueString;
		});
	}
	public clearFilter() {
		this.filterList.length = 0;
		this.filterList = [];
	}
	public getTypeFieldByName(fieldName: string): any[] {
		return this.operators[fieldName] || [];
	}
	public onSelectFieldChange(event: Event): void {
		const selectedName = (event.target as HTMLSelectElement).value;
		this.selectedField = this.fields.find((field) => field.name === selectedName);
		this.setDefaultOperators();
	}
	public getFieldLabelByName(name: string): string {
		const field = this.fields.find((field) => field.name === name);
		return field ? field.label : "";
	}
	public getOperatorLabelByTypeAndValue(type: string, value: string): string {
		const operatorsOfType = this.operators[type];
		if (operatorsOfType) {
			const operator = operatorsOfType.find((op) => op.value === value);
			return operator ? operator.label : "";
		}
		return "";
	}
	private resetValueFormFilter() {
		this.searchForm.get("field").setValue("");
		this.searchForm.get("operator").setValue("");
		this.searchForm.get("value").setValue("");
	}
	private setDefaultOperators() {
		switch (this.selectedField.type) {
			case COL_TYPES.STRING:
				this.searchForm.get("operator").setValue("contains");
				break;
			case COL_TYPES.NUMBER:
				this.searchForm.get("operator").setValue("eq");
				break;
			case COL_TYPES.BOOL:
				this.searchForm.get("operator").setValue("true");
				break;
			case COL_TYPES.DATE:
				this.searchForm.get("operator").setValue("eq");
				break;
		}
	}
}
